module.exports = __webpack_public_path__ + "static/media/A (9).f203ff12.jpg";